import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "order-info" }
const _hoisted_3 = {
  key: 0,
  class: "order-id"
}
const _hoisted_4 = {
  key: 1,
  class: "order-id"
}
const _hoisted_5 = { class: "amount-unit" }
const _hoisted_6 = { class: "amount" }
const _hoisted_7 = { class: "order-last-time" }
const _hoisted_8 = { key: 2 }

import { ref, PropType, computed } from 'vue';
import Unpaid from './Unpaid.vue';
import Countdown from '../widget/Countdown.vue';
import { ORDER_PAGE_STATUS, CHANNEL, OrderInfo } from '../utils/config';


export default /*@__PURE__*/_defineComponent({
  __name: 'Mobile',
  props: {
  orderData: {
    type: (Object as PropType<OrderInfo>) || undefined,
    required: true,
  },
  timeText: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;
const showOrderNo = computed(() => {
  return props.orderData?.orderNo && props.orderData.orderNo !== 'null';
});
const orderStatus = ref<ORDER_PAGE_STATUS>(ORDER_PAGE_STATUS.UNPAID);
const isTimeout = ref<boolean>(false);
const currentChannel = ref<CHANNEL>(CHANNEL.WECHAT);
const qrcodeUrl = ref<string>('');

// 切换页面的事件
const changePaymentStatus = (status: ORDER_PAGE_STATUS, channel?: CHANNEL, codeUrl?: string) => {
  orderStatus.value = status;
  channel ? (currentChannel.value = channel) : null;
  codeUrl ? (qrcodeUrl.value = codeUrl) : null;
};

// 订单超时状态，切换全局状态
const changeTimeoutStatus = (status: boolean) => {
  isTimeout.value = status;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (orderStatus.value !== _unref(ORDER_PAGE_STATUS).PAID)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (showOrderNo.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "订单号：" + _toDisplayString(__props.orderData?.orderNo), 1))
              : (__props.orderData?.contractNo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 签约号：" + _toDisplayString(__props.orderData?.contractNo), 1))
                : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_5, [
              _cache[0] || (_cache[0] = _createTextVNode(" ¥ ")),
              _createElementVNode("span", _hoisted_6, _toDisplayString(__props.orderData?.price), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[1] || (_cache[1] = _createTextVNode(" 剩余支付时间： ")),
              _createVNode(Countdown, {
                orderData: __props.orderData,
                fontSize: 20,
                timeText: __props.timeText,
                lastTime: __props.orderData?.timeleft,
                currentTime: __props.orderData?.currentTime,
                changeTimeoutStatus: changeTimeoutStatus,
                changePaymentStatus: changePaymentStatus
              }, null, 8, ["orderData", "timeText", "lastTime", "currentTime"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (orderStatus.value === _unref(ORDER_PAGE_STATUS).UNPAID)
      ? (_openBlock(), _createBlock(Unpaid, {
          key: 1,
          orderData: __props.orderData,
          isTimeout: isTimeout.value,
          changePaymentStatus: changePaymentStatus
        }, null, 8, ["orderData", "isTimeout"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, "订单状态异常，请刷新重新查询订单状态"))
  ], 64))
}
}

})